module.exports = __webpack_public_path__ + "static/media/tm.33f1c1cd.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/tm.svg
// module id = 1049
// module chunks = 0